import { PropsWithChildren, useEffect, useState } from 'react';
import useAuthStore from './datastore/useAuth';
import LoadingSpinner from './components/loadingSpinner/LoadingSpinner';

export default function AppInitializer({ children }: PropsWithChildren) {
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const initApp = async () => {
            useAuthStore.getState().init();
            try {
                await useAuthStore.getState().refreshToken();
            } catch (err) {
                console.warn('AppInitializer: token refresh failed or no token available', err);
            } finally {
                if (isMounted) {
                    setIsInitialized(true);
                }
            }
        };

        initApp();

        return () => {
            isMounted = false;
        };
    }, []);

    if (!isInitialized) {
        return <LoadingSpinner isLoading={true} />;
    }

    return <>{children}</>;
}
